import React, { useState } from "react";
import PropTypes from "prop-types";

import conditionalClassName from "../../../../lib/utils/conditional-class-name";
import { ClickAwayListener } from "@mui/material";

const Dropdown = ({
  children,
  className = "",
  parentLink,
  anchorClassName,
  dropdownClassName,
}) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const renderDropdown = () => {
    const _dropdownClassName = dropdownClassName ? dropdownClassName : "dropdown-menu";

    return <ul className={_dropdownClassName}>{children}</ul>;
  };

  const _className = conditionalClassName(open, "open", `dropdown-toggle ${className}`);
  const aClassName = anchorClassName ? anchorClassName : "dropdown-toggle";

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <li className={_className} onClick={handleClick}>
        <a data-testid="t-Dropdow-a" className={aClassName}>
          <span>{parentLink.text}</span>
          <span className="caret"></span>
        </a>
        {renderDropdown()}
      </li>
    </ClickAwayListener>
  );
};

Dropdown.propTypes = {
  className: PropTypes.string,
  anchorClassName: PropTypes.string,
  dropdownClassName: PropTypes.string,
  parentLink: PropTypes.shape({
    text: PropTypes.string.isRequired,
  }),
  children: PropTypes.node,
};

export default Dropdown;
